import CryptoJS from "crypto-js";



const securityKey =
    "jbgjbfgjkdfxmv jbvjfddm vv jkdhgdkfgndfv mfbgdflslkgfdn jkhgifhdfknsvfjf jbgjbfgjkdfxmv jbvjfddm vv jkdhgdkfgndfv mfbgdflslkgfdn jkhgifhdfknsvfjf";


export const authkey = 'cefe236d07d1c079bf8691c82a1d45eae498c8cb4c2eb05b';
export const authtoken = '65542739ca05391e3b21c3bf38ec939cfdc318c46778f64a';

export const setItem = (data, key) => {
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        securityKey
    ).toString();
    localStorage.setItem(key, ciphertext);
};

export const getItem = (key) => {
    if (typeof localStorage.getItem(key) != "undefined") {
        const ciphertext = localStorage.getItem(key);
        if (!ciphertext) return null;
        const bytes = CryptoJS.AES.decrypt(ciphertext, securityKey);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;
    }
    return null;
};
